import { useEffect, useRef, useState } from "react";
import { Download, FileText, Loader2, Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { sel } from "@/lib/finance";

export default function ImportDocs({ imp, canEdit }) {
  const [res, setRes] = useState(null);
  const [cat, setCat] = useState("commercial_invoice");
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const load = () => api.get(`/imports/${imp.id}/documents`).then(({ data }) => setRes(data));
  useEffect(() => { load(); }, [imp.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const upload = async (files) => {
    if (!files?.length) return;
    const fd = new FormData();
    fd.append("category", cat);
    [...files].forEach((f) => fd.append("files", f));
    setBusy(true);
    try { await api.post(`/imports/${imp.id}/documents`, fd); toast.success(`${files.length} doküman yüklendi`); load(); } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };
  const open = async (d, download) => {
    try { const { data } = await api.get(`/imports/documents/${d.id}/url`, { params: { download } }); window.open(data.url, "_blank", "noopener"); } catch (e) { toast.error(apiError(e)); }
  };
  const del = async (d) => {
    if (!window.confirm(`${d.file_name} kaldırılsın mı?`)) return;
    try { await api.delete(`/imports/documents/${d.id}`); load(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="panel overflow-hidden" data-testid="import-docs">
      <div className="flex flex-wrap items-center gap-2 px-3 py-2 border-b border-slate-200">
        <FileText className="h-4 w-4 text-slate-500" /><span className="text-[13px] font-semibold">Dokümanlar</span>
        {canEdit && res && (<>
          <select className={`${sel} h-8 ml-auto`} value={cat} onChange={(e) => setCat(e.target.value)} data-testid="import-doc-category">
            {Object.entries(res.categories).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
          <input ref={ref} type="file" multiple className="hidden" onChange={(e) => upload(e.target.files)} data-testid="import-doc-input" />
          <Button size="sm" variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid="import-doc-upload">{busy ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Upload className="h-4 w-4 mr-1" />}Yükle (en fazla 20 MB)</Button>
        </>)}
      </div>
      {!res ? <div className="p-3"><Loader2 className="h-4 w-4 animate-spin" /></div> : res.items.length === 0 ? <div className="p-3 text-[12px] text-slate-400">Doküman yok</div> : (
        <table className="erp-table text-[12px]"><thead><tr><th>Kategori</th><th>Dosya</th><th>Yükleyen</th><th /></tr></thead>
          <tbody>{res.items.map((d) => (
            <tr key={d.id} data-testid={`import-doc-${d.id}`}><td>{d.category_label}</td><td><button className="text-blue-700 hover:underline" onClick={() => open(d, false)}>{d.file_name}</button> <span className="text-slate-400">{Math.ceil(d.size / 1024)} KB</span></td>
              <td>{d.uploaded_by_name} · {formatDate(d.uploaded_at)}</td>
              <td className="text-right whitespace-nowrap"><button onClick={() => open(d, true)} className="text-slate-500 hover:text-slate-900 mr-2"><Download className="h-4 w-4" /></button>
                {canEdit && <button onClick={() => del(d)} className="text-slate-400 hover:text-rose-600" data-testid={`import-doc-delete-${d.id}`}><Trash2 className="h-4 w-4" /></button>}</td></tr>))}</tbody></table>)}
    </div>
  );
}
